<kh-dialog-header mat-dialog-title>Potential data overwrite </kh-dialog-header>

<div mat-dialog-content>
    <p class="kh-text-spacing body-large">
        The following {{ overriddenSites.length }} {{ siteVsSites }} from your shapefile already exist in your SMARTS
        app. Uploading this data will overwrite existing details for {{ theseVsThis }} {{ siteVsSites }}, including
        {{ siteAliasLowerCase }} name, geojson, and charge number.
    </p>
    <p class="body-large kh-bold-text">How would you like to proceed?</p>
    <kendo-grid
        [data]="dataSource"
        [height]="200"
        class="kh-grid-header-left-align kh-duplicate-sites-grid"
    >
        <kendo-grid-column
            field="siteNo"
            [title]="siteNumberTitle"
        ></kendo-grid-column>
    </kendo-grid>
</div>
<div
    mat-dialog-actions
    class="khts-mat-dialog-actions"
    align="end"
>
    <kh-app-text-button (clicked)="closeDialog()"> Cancel </kh-app-text-button>
    <kh-app-flat-button (clicked)="onConfirm()"> Continue upload </kh-app-flat-button>
</div>
